import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import PropTypes from "prop-types";

const HeaderSimpleTable = ({ tableData }) => {
  const headerTableColumns = [
    { header: "Name", field: "name" },
    { header: "Explanation", field: "explanation" },
  ];
  const data = tableData;
  return (
    <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
      <Table sx={{ borderCollapse: "collapse", border: "2px solid #E0E0E0", minWidth: "400px" }}>
        <TableHead>
          <TableRow sx={{ background: "#FAFAFA" }}>
            {headerTableColumns?.map((column) => (
              <TableCell
                key={column.field}
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#000",
                  border: "2px solid #E0E0E0",
                }}
              >
                {column.header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((row) => {
            const rowKey = row?.id || row?.name || JSON.stringify(row);
            return (
              <TableRow key={rowKey}>
                {headerTableColumns.map((column) => (
                  <TableCell
                    key={`${rowKey}-${column.field}`}
                    sx={{
                      fontSize: "16px",
                      borderRight:
                        column !== headerTableColumns[headerTableColumns.length - 1]
                          ? "2px solid #E0E0E0"
                          : "none",
                    }}
                  >
                    {row[column.field]}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

HeaderSimpleTable.propTypes = {
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      explanation: PropTypes.string,
    })
  ),
};

export default HeaderSimpleTable;
